import { ReactComponent as SurveyIcon } from "../../../assets/icons/nav_survey.svg";
import { useTheme } from "@mui/material";

const IconSurvey: React.FC = (props) => {
  const theme = useTheme();
  return (
    <SurveyIcon
      width="24px"
      height="24px"
      style={{
        padding: "2px",
        fill: theme.palette.text.primary,
      }}
    />
  );
};

export default IconSurvey;
